import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
import { createSelector } from "reselect";
import { formatDate } from "../../helpers/formatDate";
import { getMyNotification } from "../../store/actions";
import { getTicketById } from "../../store/ticket/actions";

export default function AllNotifications() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [allNotifications, setAllNotifications]=useState([])  

  const notificationsSelector = createSelector(
    (state) => state.Common,
    (Common) => Common.notifications
  );

  const notifications = useSelector(notificationsSelector);

  useEffect(() => {
    const merged = [...allNotifications, ...notifications];
  
    const uniqueNotifications = merged.filter(
      (item, index, self) =>
        index ===
        self.findIndex((t) => t.ticket?.createdAt === item.ticket?.createdAt)
    );
  
    setAllNotifications(uniqueNotifications);
  }, [notifications]);
  


  useEffect(() => {
    loadNotifications(1);
  }, [dispatch]);

  const loadNotifications = (page) => {
    setLoading(true);
    dispatch(getMyNotification(page, 10));
    setCurrentPage(page);
    setLoading(false);
  };

  const handleViewDetails = (id) => {
    alert(`Viewing Details for Notification ${id}`);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <h3 className="mb-4">Notifications</h3>
          <div>
            {allNotifications && allNotifications.length > 0 ? (
              <>
                <Row  className="justify-content-center">
                  {allNotifications.map((notification) => (
                    <Col
                      lg={8}
                      key={notification.ticketId}
                      className="justify-content-center cursor-pointer"
                    >
                      <NotificationCard
                        notification={notification}
                        onViewDetails={() =>
                          handleViewDetails(notification.ticketId)
                        }
                        dispatch={dispatch}
                      />
                    </Col>
                  ))}
                </Row>

                <div className="d-flex justify-content-center mt-3">
                  <Button
                    color="primary"
                    onClick={() => loadNotifications(currentPage + 1)}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Load More"}
                  </Button>
                </div>
              </>
            ) : (
              <p className="text-center mt-5">No notifications available</p>
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

const NotificationCard = ({ notification, dispatch }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        dispatch(getTicketById(notification.ticketId, navigate, false));
      }}
      className="p-3 d-flex bg-white shadow-lg "
    >
      <div className="flex-shrink-0 me-3">
        <div className="avatar-xs">
          <span className="avatar-title bg-success rounded-circle font-size-16">
            <i className="ri-checkbox-circle-line"></i>
          </span>
        </div>
      </div>
      <div className="flex-grow-1">
        <h6 className="mb-1">{notification.title}</h6>
        <div className="font-size-12 text-muted">
          <p className="mb-1">{notification.message}</p>
          <p className="mb-0">
            <i className="mdi mdi-clock-outline"></i>{" "}
            {formatDate(notification.createdAt)}
          </p>
        </div>
      </div>
    </div>
  );
};

NotificationCard.propTypes = {
  notification: PropTypes.shape({
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    createdAt: PropTypes.string.isRequired,
    isRead: PropTypes.bool,
  }).isRequired,
  onViewDetails: PropTypes.func.isRequired,
};
